import React from 'react';

interface ItalicIconProps {
    color?: string;
    width?: number;
    height?: number;
}

const ItalicIcon: React.FC<ItalicIconProps> = ({
    color = 'black',
    width = 16,
    height = 16
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_22414_739)">
                <path
                    d="M4.57144 14.8572L11.4286 1.14288"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.85715 1.14288H15.4286"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.571442 14.8572H9.14287"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_22414_739">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ItalicIcon;
